import classNames from 'classnames';
import { forwardRef } from 'react';
const contentCss = "crh3dh6";
export const Content = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentCss, props.className)} />;
});
const fieldsContainerCss = "f1mjx13m";
export const FieldsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldsContainerCss, props.className)} />;
});

require("./elements.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./elements.js");